export const ENV_SETTINGS = 'prod'
